import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { Payload, VideoCompleteResult } from '../types';
import { EVENTS } from '../constants';
import { mapBase } from './mapBase';

export const mapVideoComplete = (
    triggerName: ANALYTICS_TRIGGERS,
    payload: Payload
): VideoCompleteResult => {
    const assetDuration = (payload.payload.duration || 0) / 1000;
    const duration = Math.round(assetDuration * 0.9);
    return {
        ...mapBase(payload),
        action: EVENTS.VIDEO_COMPLETE,
        event_trigger: triggerName,
        thing_id: payload.payload.asset?.id || '',
        progress_pct: 90,
        duration,
    };
};
